/* Styling for the apportionment pages */
.article {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.tableDiv {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.tableTitle {
  margin-bottom: 1.5rem;
}

.tableInformation {
  display: block;
  width: 39rem;
  margin-bottom: 2rem;
}

.footnotesList {
  counter-reset: li;
  margin: 0;
  padding: 0;

  li {
    margin-bottom: 1rem;
    position: relative;
    display: block;

    &::before {
      content: counter(li);
      counter-increment: li;
      vertical-align: super;
      font-size: small;
      padding-right: 0.5rem;
    }
  }
}

.footnoteNumber {
  display: inline-block;
  padding-right: 0.25rem;
  font-weight: normal;
}

td > .footnoteNumber {
  margin-left: 0;
  margin-bottom: 1rem;
  padding-right: 0;
}

/* Styling for the apportionment tables */
.table {
  max-width: 52rem;
  td {
    line-height: 1.5rem;
  }
  th {
    text-wrap: nowrap;
  }
  th[scope="row"] {
    font-size: var(--font-size-md);
  }
}

.listNumberColumn {
  min-width: 3.5rem;
  width: 3.5rem;
  max-width: 3.5rem;
}

.bt1Gray {
  border-top: 1px solid var(--bg-gray-darkest);
}

.rowWithoutLink {
  td:last-of-type {
    padding-right: 4.5rem;
  }
}

.scrollable {
  width: calc(100vw - 10rem);
  overflow-x: auto;
}

.sticky {
  position: sticky;
  z-index: 1;
  background-color: var(--bg-gray);
}

table.electionSummaryTable {
  tr {
    th {
      color: var(--base-black);
    }
    td:first-of-type {
      width: fit-content;
    }
    /* Description or extra information */
    td:last-of-type {
      color: var(--color-help-text);
    }
  }
}

table.fullSeatsTable {
  tr {
    th {
      /* Signs (: and =) */
      &:nth-of-type(3),
      &:nth-of-type(5) {
        width: 2rem;
      }
      &:first-of-type,
      &:last-of-type {
        min-width: fit-content;
      }
    }
  }
}

table.residualSeatsCalculationTable {
  max-width: 34rem;
}

table.highestAveragesTable {
  max-width: calc(100vw - 10rem);
  width: fit-content;
  tr {
    /* List number sticky column */
    td:first-child,
    th:first-child {
      left: 0;
    }
    /* List name and 'residual seat added to list' text sticky column */
    td:nth-child(2),
    th:nth-child(2) {
      left: 4.55rem;
    }
    /* Number of residual seats sticky column */
    td:last-child,
    th:last-child {
      right: 0;
    }
  }
}

/* Styling for the deceased candidates and drawing lots alerts */
.smallAlert {
  div:global(.small) {
    max-width: 52rem;
    width: 100%;
    align-items: flex-start;

    section {
      max-width: 100%;

      p,
      ul {
        max-width: 100%;
      }
    }
  }
}

.drawingLotsAlert {
  overflow: hidden;
  margin: -2.5rem -5rem 0.5rem -5rem;
}

/* Styling for the apportionment finalised alert buttons */
.alertButtons {
  display: flex;
  gap: 1rem;
}

/* Styling for drawing lots pages */
.drawingLotsList {
  margin: 0;
}
